import Presenters from '@/images/SPPlus.png';
import { atom, useRecoilState } from 'recoil';
import UpgradePlanModal from './UpgradePlanModal';

export const upgradeFreePlanModalOpen = atom<boolean>({
    key: 'upgradeFreePlanModalOpen',
    default: false,
});

const UpgradeFreePlanModal = ({ from }: { from: string }) => {
    const [open, setOpen] = useRecoilState<boolean>(upgradeFreePlanModalOpen);

    return (
        <UpgradePlanModal
            open={open}
            onClose={() => setOpen(false)}
            title={<div>Upgrade to create unlimited videos</div>}
            imageFile={Presenters}
            ctaText={'Upgrade now'}
            from={from}
            features={['Unlimited video creation', 'Longer videos', 'Express avatars', 'Premium voices', 'Voice clones', 'Embedded agents']}
        />
    );
};

export default UpgradeFreePlanModal;
